import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var DialogSecondaryActions = forwardRef(function DialogSecondaryActions(_a, ref) {
    var sx = _a.sx, props = __rest(_a, ["sx"]);
    var mergeStyles = useTheme().mergeStyles;
    var baseStyle = mergeStyles([
        {
            display: "flex",
            pt: "20px",
            pb: [0, "20px"],
            pl: "24px",
            pr: ["24px", "8px"],
            gap: "5",
            gridArea: "secondaryActions",
        },
        sx,
    ]);
    return jsx(Box, __assign({ ref: ref, sx: baseStyle }, props));
});

export { DialogSecondaryActions };
//# sourceMappingURL=DialogSecondaryActions.js.map
